import React, { useState, useEffect } from "react";
import ScanMeHeader from "../../components/scanMe/HeaderScanMe";
import ScanmeLanding from "./scanmeLanding";
import TravelCareMembership from "./TravelCareMembership";
import FlightDetails from "./FlightDetails";
import Country from "./Country";
import ReachMe from './ReachMe';
import { Button, Container, Grid, createTheme, ThemeProvider } from "@mui/material";
import { scanmeLanding, saveScanmedata } from "../../api";
import { useParams } from "react-router-dom";
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux'; // Import useDispatch
import { setScanmeData } from "../../redux/scan-me/action";
import '../../assets/extra/css/extra-style.css'
import { useLocation } from 'react-router-dom';

const stepValidationSchemas = [
    null, // No validation for step 0
    null, // No validation for step 1
    // null, // No validation for step 2
    
    // rows: Yup.array().of(Yup.object().shape({
        //     date: Yup.date().required('Date is required'),
        //     flight: Yup.string().required('Flight is required'),
        // })),
        
        // rows: Yup.array().min(1, " Date and Flight both are required"),
        // countries: Yup.array().min(1, "At least one country is required")
        Yup.object().shape({
        countries: Yup.array()
                      .required("At least one country is required")
                      .min(1, 'At least one country is required')
    }),
    
    Yup.object().shape({
        whatsAppNumber: Yup.string()
            .matches(/^[0-9]{10}$/, 'Please enter a valid phone number')
            .required('Required'),
        email: Yup.string()
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,'Invalid email address')
            .required('Required'),
    }),
    null, // No validation for step 4
    null  // No validation for step 5
];

const theme = createTheme({
    typography: {
        fontFamily: 'Poppins, sans-serif',
    }
})

const TravelCareStepper = ({ initialTravellerData }) => {
    const [travellerData, setTravellerData] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [rows, setRows] = useState([{ date: '', time : '',flight: '' }]);
    const [whatsAppNumber, setWhatsAppNumber] = useState('');
    const [email, setEmail] = useState('');
    const [inputPassport, setInputPassport] = useState('')
    const [isAddMoreButtonClicked, setIsAddMoreButtonClicked]=useState(false)
    const location = useLocation();
    const dispatch = useDispatch(); // Get dispatch function
    const params = useParams();
    const id = params.id;
    const fetchData = async () => {
        try {
            const result = await scanmeLanding(id);
            const data = result.data.result;
            console.log("this is data",data)
            setTravellerData(data); 
            dispatch(setScanmeData(data)); // <<< Dispatch action to store in Redux
        } catch (err) {
            console.error(err);
            dispatch(setScanmeData(null)); // Optional: Clear Redux state on error
        }
    };
    useEffect(() => {
        
        if (location.state?.travellerData) {
            setTravellerData(location.state.travellerData);
            dispatch(setScanmeData(location.state.travellerData));
            // setActiveStep(1);
            handleNext()
          } else {
            // If no prop data, fallback to fetch from API
            fetchData();
        }
    }, [id,dispatch,initialTravellerData]);

    const { register, handleSubmit, trigger, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(stepValidationSchemas[activeStep]),
        mode: "onBlur"
    });

    const steps = ["Landing", "Travel Details", "Flight Details", "Country Details", "Thank You"];

    const handleNext = async () => {
        if (activeStep === steps.length - 2) {
            handleSubmitData();
        };

        if (activeStep === steps.length - 3) {
            
        }

        if (stepValidationSchemas[activeStep]) {
            const schema = stepValidationSchemas[activeStep]
            const isValid = await trigger(Object.keys(schema.fields))
            if (!isValid) return;
        }
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const handleSubmitData = async () => {
        const countries = selectedCountries.map((item) => item.name)
        const formData = {
            countries,
            flightDetails: rows,
            whatsappNumber: whatsAppNumber,
            email: email,
            passport: inputPassport,
            document_id: id
        };

        try {
             await saveScanmedata(formData);
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    const handlePassportChange = (passport)=>{
        setInputPassport(passport)
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <>
                        <ScanmeLanding 
                        travellerData={travellerData} 
                        onPassportMatch={handleNext} 
                        onPassportChange={handlePassportChange}
                        />
                        {/* <ServiceDetails/> */}
                    </>
                );
            case 1:
                return (
                    <>
                        <TravelCareMembership travellerData={travellerData} />
                    </>
                );
            case 2:
                return (
                    <Country
                        selectedCountries={selectedCountries}
                        setSelectedCountries={setSelectedCountries}
                        rows={rows}
                        setRows={setRows}
                        register={register}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        onSubmit={handleSubmitData}
                        setValue={setValue}
                        trigger={trigger}
                        isAddMoreButtonClicked={isAddMoreButtonClicked}
                        setIsAddMoreButtonClicked={setIsAddMoreButtonClicked}
                        travellerData={travellerData}
                    />
                );
            case 3:
                return (
                    <>
                        <FlightDetails
                            whatsAppNumber={whatsAppNumber}
                            setWhatsAppNumber={setWhatsAppNumber}
                            email={email}
                            setEmail={setEmail}
                            register={register}
                            errors={errors}
                            handleSubmit={handleSubmit}
                            onSubmit={handleSubmitData}
                            setValue={setValue}
                        />
                    </>
                );
            case 4:
                return (
                    <ReachMe />
                );

            default:
                return "Unknown step";
        }
    };

    return (
        <>
        <ThemeProvider theme={theme}>
            <ScanMeHeader activeStep={activeStep} />
            <Container className="stepper-container">
                <Grid container justifyContent="center" alignItems="center">
                    {getStepContent(activeStep)}
                </Grid>
                <Grid container className="sticky-bottom mb-5" spacing={2}>
                    <Grid item xs={6} container justifyContent="flex-start">
                        {activeStep !== 0 && activeStep !== 1 && activeStep !== steps.length - 1 && (
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ ml: 3, backgroundColor: '#fcc000', borderRadius: '20px', color: 'white', textTransform: 'none' }}
                            >
                                Back
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end">
                         {activeStep !== 0 && activeStep !== steps.length - 1 && ( 
                            <Button
                                className="stepper-next-btn"
                                color="warning"
                                onClick={handleNext}
                                disabled={activeStep === steps.length - 1}
                                sx={{ mr: 3 , textTransform: 'none'}}
                            >
                                {activeStep === steps.length - 1 ? "Finish" : "Next"}
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Container>

        </ThemeProvider>
        </>
    );
};

export default TravelCareStepper;